<template>
  <div class="page-shell product-page-v11">
    <section class="product-hero">
      <div class="product-hero__inner">
        <div class="product-hero__copy">
          <div class="page-eyebrow">About ZhiXun Cube</div>
          <h1>关于智训立方</h1>
          <p>
            智训立方是面向应急教学、案例训练和情景交互学习的在线培训平台，帮助用户把课程、案例与训练过程转化为可学习、可体验、可复盘的训练资源。
          </p>
          <div class="product-hero__actions">
            <router-link to="/more">查看经典案例</router-link>
            <router-link to="/help" class="ghost">查看帮助中心</router-link>
          </div>
        </div>
        <div class="product-hero__panel modern-card">
          <div class="panel-title">平台关键词</div>
          <div class="keyword-cloud">
            <span v-for="tag in tags" :key="tag">{{ tag }}</span>
          </div>
        </div>
      </div>
    </section>

    <section class="page-container product-main">
      <div class="position-grid">
        <div class="position-card modern-card">
          <span>01</span>
          <h2>平台定位</h2>
          <p>
            面向应急管理、消防救援、安全生产、公共安全等培训场景，提供在线案例学习、情景化训练、课程管理和学习记录支持。
          </p>
        </div>
        <div class="position-card modern-card strong">
          <span>02</span>
          <h2>核心价值</h2>
          <p>
            让传统课程和案例资料从“被动阅读”走向“情景理解、交互学习、任务训练和复盘提升”。
          </p>
        </div>
      </div>

      <div class="capability-block modern-card">
        <div class="section-heading">
          <div>
            <h2>平台能力</h2>
            <p>以课程、案例、情景和复盘提升为核心，支撑多角色学习训练。</p>
          </div>
        </div>
        <div class="capability-grid">
          <div class="capability-item" v-for="item in capabilities" :key="item.title">
            <div class="capability-icon"><i :class="item.icon"></i></div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>

      <div class="service-block">
        <div class="section-heading compact-heading">
          <div>
            <h2>适用对象与场景</h2>
            <p>适用于院校教学、单位培训、案例展示、桌面推演前置学习、情景训练资源建设等场景。</p>
          </div>
        </div>
        <div class="scene-grid">
          <div class="scene-card modern-card" v-for="scene in scenes" :key="scene.title">
            <div class="scene-icon"><i :class="scene.icon"></i></div>
            <h3>{{ scene.title }}</h3>
            <p>{{ scene.desc }}</p>
          </div>
        </div>
      </div>

      <div class="support-strip modern-card">
        <div>
          <h2>服务支持</h2>
          <p>平台由北京数字维尔科技有限公司提供建设与技术支持。</p>
        </div>
        <div class="support-list">
          <span>技术支持：support@zhi119.com</span>
          <span>商务咨询：marketing@zhi119.com</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      capabilities: [
        { title: "在线课程学习", desc: "支持用户进入课程和案例资源，开展结构化学习。", icon: "el-icon-reading" },
        { title: "情景化案例训练", desc: "围绕典型应急场景进行交互式理解与任务训练。", icon: "el-icon-data-board" },
        { title: "多角色使用", desc: "面向教师、学员、管理员等不同角色提供不同入口。", icon: "el-icon-user" },
        { title: "学习记录支持", desc: "为课程学习、训练记录和复盘讲评提供基础支撑。", icon: "el-icon-document-checked" },
      ],
      scenes: [
        { title: "院校教学", desc: "适合课堂案例讲解、课程辅助、学生情景认知训练。", icon: "el-icon-school" },
        { title: "单位培训", desc: "适合消防、应急、安全生产等单位开展内部培训。", icon: "el-icon-office-building" },
        { title: "案例展示", desc: "适合将典型案例转化为可访问、可体验的在线资源。", icon: "el-icon-collection" },
        { title: "训练准备", desc: "适合作为桌面推演、实操训练前的前置学习入口。", icon: "el-icon-guide" },
      ],
      tags: ["应急教学", "案例培训", "情景训练", "在线课程", "任务学习", "复盘提升", "多角色使用", "资源建设"],
    };
  },
};
</script>

<style scoped lang="scss">
.product-hero {
  position: relative;
  padding: 76px 0 42px;
  background:
    radial-gradient(circle at 12% 0%, rgba(47, 111, 237, 0.12), transparent 32%),
    radial-gradient(circle at 88% 6%, rgba(32, 200, 255, 0.12), transparent 30%),
    linear-gradient(135deg, #f8fbff 0%, #eef5ff 58%, #f7fbff 100%);
}

.product-hero__inner {
  width: min(1180px, calc(100% - 48px));
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 34px;
  align-items: center;
}

.product-hero h1 {
  margin: 18px 0;
  color: var(--brand-blue-deep);
  font-size: clamp(34px, 3vw, 46px);
  line-height: 1.15;
  font-weight: 880;
}

.product-hero p {
  color: #475569;
  font-size: 16px;
  line-height: 1.85;
}

.product-hero__actions {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 30px;
}

.product-hero__actions a {
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  border-radius: 999px;
  text-decoration: none;
  color: #fff;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color) 62%, var(--tech-cyan));
  box-shadow: 0 12px 24px rgba(21, 87, 216, 0.20);
  font-weight: 700;
  transition: all 0.22s ease;
}

.product-hero__actions a.ghost {
  color: var(--brand-blue-deep);
  background: #fff;
  box-shadow: none;
  border: 1px solid var(--border-color);
}

.product-hero__actions a:hover {
  transform: translateY(-2px);
}

.product-hero__panel {
  padding: 20px;
}

.panel-title {
  color: var(--brand-blue-deep);
  font-size: 20px;
  font-weight: 950;
  margin-bottom: 16px;
}

.keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.keyword-cloud span {
  padding: 8px 12px;
  border-radius: 999px;
  color: var(--secondary-color);
  background: rgba(47, 111, 237, 0.10);
  font-weight: 760;
}

.product-main {
  padding-top: 30px;
}

.position-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.position-card {
  padding: 26px;
}

.position-card span {
  color: var(--primary-color);
  font-size: 13px;
  font-weight: 800;
}

.position-card h2,
.support-strip h2 {
  margin: 12px 0 14px;
  color: var(--brand-blue-deep);
  font-size: 23px;
  font-weight: 820;
}

.position-card p,
.support-strip p {
  color: var(--gray-text);
  font-size: 15px;
  line-height: 1.8;
}

.position-card.strong {
  background: linear-gradient(135deg, #123a6f, #0f2f5f);
}

.position-card.strong span,
.position-card.strong h2,
.position-card.strong p {
  color: #fff;
}

.capability-block {
  padding: 26px;
  margin-bottom: 24px;
}

.capability-grid,
.scene-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.capability-item,
.scene-card {
  padding: 20px;
  border-radius: 18px;
  background: #f8fafc;
  border: 1px solid #edf2f7;
}

.capability-icon,
.scene-icon {
  width: 48px;
  height: 42px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  color: var(--primary-color);
  background: rgba(47, 111, 237, 0.10);
  font-size: 20px;
  margin-bottom: 16px;
}

.capability-item h3,
.scene-card h3 {
  color: var(--brand-blue-deep);
  font-size: 17px;
  font-weight: 800;
  margin-bottom: 10px;
}

.capability-item p,
.scene-card p {
  color: var(--gray-text);
  font-size: 14px;
  line-height: 1.7;
}

.service-block {
  margin: 28px 0 20px;
}

.compact-heading {
  margin-bottom: 22px;
}

.support-strip {
  padding: 26px;
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  gap: 24px;
  align-items: center;
}

.support-list {
  display: grid;
  gap: 12px;
}

.support-list span {
  padding: 11px 14px;
  border-radius: 14px;
  color: var(--brand-blue-deep);
  background: #f8fafc;
  border: 1px solid #edf2f7;
  font-weight: 800;
}

@media (max-width: 980px) {
  .product-hero__inner,
  .position-grid,
  .support-strip {
    grid-template-columns: 1fr;
  }

  .capability-grid,
  .scene-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 640px) {
  .product-hero__inner {
    width: min(100% - 28px, 100%);
  }

  .capability-grid,
  .scene-grid {
    grid-template-columns: 1fr;
  }
}

.product-hero__panel,
.position-card,
.capability-block,
.scene-card,
.support-strip {
  position: relative;
  overflow: hidden;
}

.product-hero__panel::after,
.position-card::after,
.capability-block::after,
.scene-card::after,
.support-strip::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  border-radius: inherit;
  box-shadow: inset 0 0 0 1px rgba(32, 200, 255, 0.06);
}

@media (max-width: 640px) {
  .product-hero {
    padding: 56px 0 30px;
  }

  .product-hero h1 {
    font-size: 30px;
  }

  .position-card,
  .capability-block,
  .support-strip {
    padding: 22px;
  }
}
</style>
